export default "__VITE_ASSET__DAOSfvs___"